import { defineMessages } from 'react-intl';

export const i18n = defineMessages({
  title: {
    id: 'knowledgeBase.title',
    defaultMessage: 'Knowledge Base',
  },
  loadError: {
    id: 'knowledgeBase.loadError',
    defaultMessage: 'Failed to load the knowledge base.',
  },
  articleError: {
    id: 'knowledgeBase.articleError',
    defaultMessage: 'Failed to load this article.',
  },
  retry: {
    id: 'knowledgeBase.retry',
    defaultMessage: 'Retry',
  },
  close: {
    id: 'knowledgeBase.close',
    defaultMessage: 'Close',
  },
  menu: {
    id: 'knowledgeBase.menu',
    defaultMessage: 'Sections',
  },
  language: {
    id: 'knowledgeBase.language',
    defaultMessage: 'Language',
  },
  autoLanguage: {
    id: 'knowledgeBase.autoLanguage',
    defaultMessage: 'Auto',
  },
  open: {
    id: 'knowledgeBase.open',
    defaultMessage: 'Open knowledge base',
  },
  chooseArticle: {
    id: 'knowledgeBase.chooseArticle',
    defaultMessage: 'Choose an article from the list.',
  },
  kbRelated: {
    id: 'knowledgeBase.related',
    defaultMessage: 'Related',
  },
  openDocument: {
    id: 'knowledgeBase.openDocument',
    defaultMessage: 'Open',
  },
  downloadDocument: {
    id: 'knowledgeBase.downloadDocument',
    defaultMessage: 'Download',
  },
});
